import React from 'react';

const Context = React.createContext<HTMLElement | null>(null);

export const ToolbarBoundaryProvider: React.FC<{
  editorContainer: null | HTMLElement;
  externalContainer: undefined | (() => HTMLElement | null) | HTMLElement;
  children: React.ReactNode;
}> = ({ editorContainer, children, externalContainer }) => {
  const containerFromConfig =
    typeof externalContainer === 'function' ? externalContainer() ?? undefined : externalContainer;

  const value = React.useMemo(
    () => containerFromConfig ?? editorContainer,
    [editorContainer, containerFromConfig]
  );
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useToolbarBoundary = () => {
  return React.useContext(Context);
};
